import { render, staticRenderFns } from "./BoardFundsEditor.vue?vue&type=template&id=673b1265&"
import script from "./BoardFundsEditor.vue?vue&type=script&lang=js&"
export * from "./BoardFundsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports